// import { ProfileType } from './types'
import { ThunkAction } from '../../store/types'
import axios from 'axios'
import * as actions from './actions'

export const fetchTerm = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.fetchTermRequest())
    try {
      const resp = await axios.get('/public/privacyPolicy')
      console.log('resp', resp)
      dispatch(actions.fetchTermSuccess(resp.data))
    } catch (err) {
      console.log('err', err)
      dispatch(actions.fetchTermFail(err))
    }
  }
}

export const fetchPrivacyPolicy = (): ThunkAction => {
  return async dispatch => {
    dispatch(actions.fetchPrivacyPolicyRequest())

    try {
      const resp = await axios.get('/public/termsAndConditions')
      console.log(resp)
      dispatch(actions.fetchPrivacyPolicySuccess(resp.data))
    } catch (err) {
      dispatch(actions.fetchPrivacyPolicyFail(err))
    }
  }
}
